<template lang="pug">
.v-tariffs.tariffs(v-if="tariffs")
	.tariffs__container.container
		v-title.tariffs__title-wrapper(v-if="tariffs.title" :title="tariffs.title")
		.tariffs__tariffs-wrapper
			template(v-if="tariffs.items && tariffs.items.length"
					v-for="(tariff, tariffIndex) in tariffs.items"
					:key="tariffIndex")
				template(v-if="isSm")
					.tariffs__tariff-wrapper(:class="tariff.className || ''"
							@click="tariff.opened = !tariff.opened")
						.tariffs__tariff(:class="{'tariffs__item--opened': tariff.opened}")
							.tariffs__tariff-flag(v-if="tariff.flag") {{tariff.flag}}
							.tariffs__top-wrapper
								img.tariffs__top-label(:src="tariff.label" alt="" loading="lazy")
								.tariffs__top-description
									.tariffs__description-name(v-if="tariff.name") {{tariff.name}}
									v-price-tariff.tariffs__description-price(:price="tariff.price")
								button.tariffs__item-bar(type="button"
										aria-label="Открыть / Закрыть"
										:class="{'tariffs__item-bar--opened': tariff.opened}")
						v-collapse(:open="tariff.opened")
							.tariffs__tariff-main-cover
								.tariffs__tariff-main-wrap
									.tariffs__tariff-main
										template(v-if="tariff.points && tariff.points.length"
												v-for="(point, pointIndex) in tariff.points"
												:key="pointIndex")
											.tariffs__main-point
												template(v-if="point.type === 'on'")
													img.tariffs__point-label.tariffs__point-label--on(:src="labelOn"
															loading="lazy"
															alt="")
													.tariffs__point-text(v-if="point.text") {{point.text}}
												template(v-if="point.type === 'off'")
													img.tariffs__point-label.tariffs__point-label--off(:src="labelOff"
															loading="lazy"
															alt="")
													.tariffs__point-text.tariffs__point-text--off(v-if="point.text") {{point.text}}
												template(v-if="point.type === 'prime'")
													img.tariffs__point-label.tariffs__point-label--prime(:src="labelPrime"
															loading="lazy"
															alt="")
													.tariffs__point-text(v-if="point.text") {{point.text}}
										.tariffs__tariff-bottom-wrapper
											button.tariffs__tariff-bottom.btn.btn--black(
													type="button"
													:aria-label="tariff.button.text"
													v-if="tariff.button.text"
													@click.stop="openModal(tariff.id)")
												| {{tariff.button.text}}
				template(v-else)
					.tariffs__tariff-wrapper(:class="tariff.className || ''")
						.tariffs__tariff
							.tariffs__tariff-flag(v-if="tariff.flag") {{tariff.flag}}
							.tariffs__tariff-top
								.tariffs__top-wrapper
									img.tariffs__top-label(:src="tariff.label" alt="" loading="lazy")
									.tariffs__top-description
										.tariffs__description-name(v-if="tariff.name") {{tariff.name}}
										v-price-tariff.tariffs__description-price(:price="tariff.price")
							.tariffs__tariff-main
								template(v-if="tariff.points && tariff.points.length"
										v-for="(point, pointIndex) in tariff.points"
										:key="pointIndex")
									.tariffs__main-point
										template(v-if="point.type === 'on'")
											v-svg-icon.tariffs__point-label.tariffs__point-label--on(icon="point-label-on")
											.tariffs__point-text(v-if="point.text") {{point.text}}
										template(v-if="point.type === 'off'")
											v-svg-icon.tariffs__point-label.tariffs__point-label--off(icon="point-label-off")
											.tariffs__point-text.tariffs__point-text--off(v-if="point.text") {{point.text}}
										template(v-if="point.type === 'prime'")
											v-svg-icon.tariffs__point-label.tariffs__point-label--prime(icon="point-label-prime")
											.tariffs__point-text(v-if="point.text") {{point.text}}
						.tariffs__tariff-bottom-wrapper
							button.tariffs__tariff-bottom.btn.btn--black(
									type="button"
									@click.stop="openModal(tariff.id)"
									:aria-label="tariff.button.text"
									v-if="tariff.button.text")
								| {{tariff.button.text}}
</template>

<script>
import {mapGetters} from "vuex";
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin,
		isMobMixin,
	],

	data() {
		return {
			tariffs: null,
			isFirstDataSet: true,
			isDataUpdated: false,
			labelOn: '/local/assets/images/point-label-on.svg',
			labelOff: '/local/assets/images/point-label-off.svg',
			labelPrime: '/local/assets/images/point-label-prime.svg',
		};
	},

	computed: {
		...mapGetters({
			country: 'delivery/country',
			currency: 'delivery/currency'
		}),
	},

	watch: {
		country() {
			this.requestDataLoad();
		},

		currency() {
			this.requestDataLoad();
		}
	},

	methods: {
		openModal(tariffId) {
			controller.openModal({
				className: 'modal--md',
				component: {
					name: 'v-form',
					props: {
						dataSource: this.tariffs.form,
						tariffId: tariffId,
						media: this.tariffs.media,
						phones: this.tariffs.phones,
						className: 'call-back'
					}
				}
			});
		},

		requestDataLoad() {
			if (this.tariffs && this.tariffs.remote) {
				this.isDataUpdated = true;
				this.dataLoad({
					url: this.tariffs.remote,
					delay: true,
					data: {
						country: this.country.value,
						currency: this.currency.value
					}
				})
			}
		},

		dataSet(data) {
			if (this.isFirstDataSet) {
				this.tariffs = data;
				this.isFirstDataSet = false;
			} else if (this.isDataUpdated) {
				this.tariffs = data;
				this.isDataUpdated = false;
			}
		}
	}
};
</script>